import React, { useState } from 'react';
import { Box, Flex, Heading, IconButton, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { ArrowLeft, Bank } from 'phosphor-react';

import { GlassCard, GlassPageBg } from '../../../../../components/glass';
import { IEmpresaOption } from '../../../../../hooks/useContaCilImportar';
import { EmpresaPicker } from '../components/EmpresaPicker';
import { useAplicarEmpresaParam } from '../useEmpresaParam';
import { useVoltar } from '../useVoltar';
import { ContasTable } from './ContasTable';

export function ConciliacaoContabilBancosPage() {
  const voltar = useVoltar();
  const [empresa, setEmpresa] = useState<IEmpresaOption | null>(null);
  // Deep-link ?empresa=<id> (ex: botao "Vincular conta" do modal do Conciliar).
  useAplicarEmpresaParam(setEmpresa);

  return (
    <GlassPageBg>
      <Box maxW="1280px" mx="auto" w="full" px={{ base: 4, md: 8 }} py={{ base: 6, md: 10 }}>
        <motion.div
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, ease: [0.4, 0, 0.2, 1] }}
        >
          <Flex align="center" gap={3} mb={5}>
            <IconButton
              aria-label="Voltar"
              icon={<ArrowLeft size={18} weight="bold" />}
              variant="ghost"
              size="sm"
              borderRadius="full"
              color="#64748B"
              _hover={{ bg: 'rgba(15, 23, 42, 0.06)', color: '#0F172A' }}
              onClick={voltar}
            />
            <Box
              w="64px"
              h="64px"
              borderRadius="2xl"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bg="linear-gradient(135deg, #EDE9FE 0%, #DDD6FE 100%)"
              color="#8B5CF6"
              boxShadow="0 8px 24px -4px rgba(139, 92, 246, 0.32)"
            >
              <Bank size={34} weight="duotone" />
            </Box>
            <Box>
              <Text
                fontSize="11px"
                color="#94A3B8"
                textTransform="uppercase"
                letterSpacing="0.1em"
                fontWeight="semibold"
              >
                Conciliação Contábil
              </Text>
              <Heading fontSize={{ base: '24px', md: '32px' }} fontWeight="700" color="#0F172A">
                Contas bancárias
              </Heading>
              <Text fontSize="sm" color="#64748B">
                Vincule cada conta à sua POC — é o lado banco que fecha a conciliação.
              </Text>
            </Box>
          </Flex>
        </motion.div>

        <GlassCard intensity="medium" p={4} mb={5}>
          <EmpresaPicker value={empresa} onChange={setEmpresa} />
        </GlassCard>

        {!empresa ? (
          <GlassCard intensity="medium" p={10}>
            <Text fontSize="sm" color="#64748B" textAlign="center">
              Selecione uma empresa para ver e vincular as contas.
            </Text>
          </GlassCard>
        ) : (
          <ContasTable empresaId={empresa.value} />
        )}
      </Box>
    </GlassPageBg>
  );
}
